import React, { Suspense, lazy } from 'react';
import { NavBar } from './components/NavBar';
import { Hero } from './components/Hero';

/**
 * Pequeñas Puntadas sales page.
 * HERO → EDADES → GALERÍA → QUÉ INCLUYE → OFERTA → POR DENTRO → BONOS →
 * PREGUNTAS → CIERRE (con la línea de garantía) → FOOTER (+ barra móvil después del hero).
 * Everything below the hero loads in separate chunks; each block reserves height.
 */
const named = <K extends string,>(loader: () => Promise<Record<K, React.ComponentType>>, key: K) => lazy(() => loader().then(m => ({
  default: m[key]
})));
const AgesSection = named(() => import('./components/sections/AgesSection'), 'AgesSection');
const GallerySection = named(() => import('./components/sections/GallerySection'), 'GallerySection');
const BenefitsSection = named(() => import('./components/sections/BenefitsSection'), 'BenefitsSection');
const OfferSection = named(() => import('./components/sections/OfferSection'), 'OfferSection');
const ModelPreviewSection = named(() => import('./components/sections/ModelPreviewSection'), 'ModelPreviewSection');
const BonusSection = named(() => import('./components/sections/BonusSection'), 'BonusSection');
const FaqSection = named(() => import('./components/sections/FaqSection'), 'FaqSection');
const FinalCta = named(() => import('./components/sections/FinalCta'), 'FinalCta');
const Footer = named(() => import('./components/Footer'), 'Footer');
const StickyBuyBar = named(() => import('./components/StickyBuyBar'), 'StickyBuyBar');
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
  id?: string;
}

/** The fallback carries the section id so anchors resolve before the chunk loads. */
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory',
  id
}: DeferredProps) {
  return <Suspense fallback={<div id={id} className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="nwc2vvuco1xu" />} data-id="element-0" data-mp="nvsup6ui4rx0">
      {children}
    </Suspense>;
}
export function App() {
  return <div className="app-root bg-ivory text-graphite" data-id="element-2" data-mp="swgi7ijiuqmh">
      <NavBar data-id="element-3" data-mp="356s95xbri9l" />
      <main data-id="element-4" data-mp="34nb3rfi0xwm">
        <Hero data-id="element-5" data-mp="38kvshhq5xim" />
        <Deferred minHeight="760px" background="bg-ivory-deep" id="talles" data-id="element-6" data-mp="3uct25gan0gyw">
          <AgesSection data-id="element-7" data-mp="3uevs60bsia3m" />
        </Deferred>
        <Deferred minHeight="1800px" background="bg-blush" id="prendas" data-id="element-8" data-mp="d57fv4288kjl">
          <GallerySection data-id="element-9" data-mp="85l3sxy4xacd" />
        </Deferred>
        <Deferred minHeight="360px" data-id="element-10" data-mp="86mc4unrniqe">
          <BenefitsSection data-id="element-11" data-mp="83i1befspoqr" />
        </Deferred>
        <Deferred minHeight="900px" background="bg-ivory-deep" id="oferta" data-id="element-12" data-mp="3gklbm69y5m8n">
          <OfferSection data-id="element-13" data-mp="3bmjq7ep1tau0" />
        </Deferred>
        <Deferred minHeight="1100px" background="bg-ivory-deep" id="modelo" data-id="element-14" data-mp="3bnmk7vho3te5">
          <ModelPreviewSection data-id="element-15" data-mp="3qbfur1rwc5pv" />
        </Deferred>
        <Deferred minHeight="900px" background="bg-blush" id="bonos" data-id="element-16" data-mp="3qdafog363xty">
          <BonusSection data-id="element-17" data-mp="3liwjwcklfoor" />
        </Deferred>
        <Deferred minHeight="700px" id="preguntas" data-id="element-18" data-mp="2xuwtjdr720ap">
          <FaqSection data-id="element-19" data-mp="2xtbzdp8skjdd" />
        </Deferred>
        <Deferred minHeight="420px" background="bg-coral-deep" data-id="element-20" data-mp="2svtovuf4lw39">
          <FinalCta data-id="element-21" data-mp="2svaecyrt29z9" />
        </Deferred>
      </main>
      <Deferred minHeight="240px" background="bg-graphite-deep" data-id="element-22" data-mp="18d9ekawunsua">
        <Footer data-id="element-23" data-mp="18bomcry0clzl" />
      </Deferred>

      <Suspense fallback={null} data-id="element-24" data-mp="1d4ztyvan96sk">
        <StickyBuyBar data-id="element-25" data-mp="1d62iiwkhux5b" />
      </Suspense>
    </div>;
}